import axios from 'axios';

const prod = 'https://api.analisededados.medway.com.br/';
const dev = 'https://api.analisededados.medway.com.br/';

const apiAnaliseDeDados = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? dev : prod,
});

export default apiAnaliseDeDados;
